import * as React from "react";
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {lazyInject} from "@athena-portal/core";
import {Overlay} from "@athena-portal/components";
import {
    FEEDBACK_DIALOG_DISPLAY_COUNTER,
    FEEDBACK_DIALOG_DISPLAY_EVENT,
    ICustomerPortalService,
    Policy,
    POLICY_NUMBER_PREFIX_MAP,
    Types
} from "@falcon/services";
import {filter} from 'rxjs/operators';

interface IState {
    isOpen: boolean;
    reviewFormUrl: string | null;
    displayOverlay: boolean;
    reviewReferenceNumber: string | null;
    multiPolicyAccount: boolean;
}

export class TrustPilotFeedbackDialog extends React.Component<{}, IState> {

    private POLICY_NUMBER_REGEX: RegExp = /^[A-Za-z]{3}\d{12}$/;

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: {}) {
        super(props);
        this.state = {
            isOpen: false,
            reviewFormUrl: null,
            displayOverlay: false,
            reviewReferenceNumber: null,
            multiPolicyAccount: this.setMultiPolicyAccount()
        };
    }

    public componentDidMount(): void {
        addEventListener(FEEDBACK_DIALOG_DISPLAY_EVENT, this.displayDialog);

        const url = window.location.href.replace(/\/$/, '');
        const policyNumber = url.slice(url.lastIndexOf('/') + 1);

        if (!this.state.multiPolicyAccount && this.POLICY_NUMBER_REGEX.test(policyNumber)) {
            this.customerPortalService.getReviewRequest(policyNumber).subscribe((reviewReferenceNumber: string) => {
                    if (reviewReferenceNumber && !window[FEEDBACK_DIALOG_DISPLAY_COUNTER as keyof Window]) {
                        // @ts-ignore display feedback dialog after delay
                        window[FEEDBACK_DIALOG_DISPLAY_COUNTER as keyof Window] = setTimeout(() => {
                            dispatchEvent(new Event(FEEDBACK_DIALOG_DISPLAY_EVENT));
                        }, 30_000); // display after 30 seconds
                    }

                }
            );
        }
    }

    public componentWillUnmount(): void {
        removeEventListener(FEEDBACK_DIALOG_DISPLAY_EVENT, this.displayDialog);
    }

    public render() {
        return (
            <React.Fragment>
                <Overlay show={this.state.displayOverlay}/>
                <Modal className="trustpilot-modal" isOpen={this.state.isOpen}>
                    <ModalHeader close={<button className="btn-close" onClick={this.close}/>}>
                        We'd love your feedback
                    </ModalHeader>
                    <ModalBody>
                        <iframe src={this.state.reviewFormUrl!} onLoad={() => {
                            this.setState({displayOverlay: false})
                        }}/>
                    </ModalBody>
                </Modal>
            </React.Fragment>
        );
    }

    private setMultiPolicyAccount() : boolean {
        let multiPolicyAccount = false
        this.customerPortalService.getUserPoliciesWithLatestVersions()
            .subscribe((userPolicies: Policy[]) => multiPolicyAccount = userPolicies.length > 1)

        return multiPolicyAccount
    }

    private close = (): void => {
        this.customerPortalService.putOnHoldReviewRequest(this.state.reviewReferenceNumber!).subscribe();
        this.setState({isOpen: false});
    };

    private displayDialog = (): void => {
        const url = window.location.href.replace(/\/$/, '');
        const policyNumber = url.slice(url.lastIndexOf('/') + 1);
        const policyNumberFirstThreeChars = policyNumber.slice(0, 3);
        const isMotor = POLICY_NUMBER_PREFIX_MAP.WOLF_MOTOR.some(prefix =>
            policyNumberFirstThreeChars === prefix
        );

        if (this.POLICY_NUMBER_REGEX.test(policyNumber)) {
            // review dialog is about to be displayed - remove delayed display timer
            delete window[FEEDBACK_DIALOG_DISPLAY_COUNTER as keyof Window];

            // Skipping this logic if reviewReferenceNumber is not returned
            this.customerPortalService.getReviewRequest(policyNumber).pipe(
                filter((reviewReferenceNumber): reviewReferenceNumber is string => !!reviewReferenceNumber)
            ).subscribe((reviewReferenceNumber: string) => {
                this.setState({displayOverlay: true});
                this.setState({reviewReferenceNumber});
                // review is requested -> construct URL and display review dialog
                if (isMotor) {
                    this.customerPortalService.constructTrustPilotReviewUrlForAnnualMotor(reviewReferenceNumber)
                        .subscribe((reviewFormUrl: string) => {
                            this.customerPortalService.increaseReviewRequestAttemptCount(reviewReferenceNumber).subscribe();
                            this.setState({isOpen: true, reviewFormUrl});
                        });
                } else {
                    this.customerPortalService.constructTrustPilotReviewUrlForAnnualHome(reviewReferenceNumber)
                        .subscribe((reviewFormUrl: string) => {
                            this.customerPortalService.increaseReviewRequestAttemptCount(reviewReferenceNumber).subscribe();
                            this.setState({isOpen: true, reviewFormUrl});
                        });
                }
            });
        }
    };

}
